import { render, staticRenderFns } from "./ImageViewDialog.vue?vue&type=template&id=3d1131c0&scoped=true"
import script from "./ImageViewDialog.vue?vue&type=script&lang=js"
export * from "./ImageViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1131c0",
  null
  
)

export default component.exports